import type { JSX, ReactNode } from "react";

import { cva, cx } from "@mobsuccess-devops/styled-system/css";
import { Link, useRouter } from "@tanstack/react-router";

import { buttonStyles } from "./styles";

type ButtonStyles = NonNullable<Parameters<typeof buttonStyles>[0]>;

export type ButtonLinkProps = Omit<Parameters<typeof Link>[0], "children"> & {
  children: ReactNode;
} & Pick<ButtonStyles, "variant" | "palette" | "size">;

export function ButtonLink({
  variant,
  palette,
  className,
  color: _color,
  size,
  ...props
}: ButtonLinkProps): JSX.Element {
  const withinRouter = useRouter({ warn: false });

  if (withinRouter) {
    return (
      <Link
        className={cx(
          buttonStyles({
            variant,
            palette,
            size,
          }),
          buttonLinkStyles({
            variant,
          }),
          className,
        )}
        {...props}
      />
    );
  }
  return (
    <a
      className={cx(
        buttonStyles({
          variant,
          palette,
          size,
        }),
        buttonLinkStyles({
          variant,
        }),
        className,
      )}
      {...props}
      href={props.to}
    />
  );
}

const buttonLinkStyles = cva({
  variants: {
    variant: {
      light: {
        _hover: {
          background: "colorPalette.100",
        },
      },
      dark: {
        _hover: {
          background: "colorPalette.600",
        },
      },
      outlined: {
        _hover: {
          color: "colorPalette.500",
          background: "colorPalette.100",
          borderColor: "colorPalette.500",
        },
      },
      transparent: {
        _hover: {
          color: "colorPalette.400",
          background: "colorPalette.100",
        },
      },
    },
  },
  defaultVariants: {
    variant: "light",
  },
});
